import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Gallery from "../pages/gallery/page";
import ProjectPage from "../pages/project/page";
import FAQPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/project/:slug",
    element: <ProjectPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
